import optionsApi from "./optionsApi";
import {
  CustomField,
  CreateCustomFieldDto,
  UpdateCustomFieldDto,
  UdfEntityType,
} from "../types/CustomFields";

export async function getCustomFields(
  entityType?: UdfEntityType
): Promise<CustomField[]> {
  const params = entityType ? { entityType } : {};
  return optionsApi
    .get("v1/customFields", { params })
    .then((res) => res.data.data.customFields);
}

export async function createCustomField(
  dto: CreateCustomFieldDto
): Promise<CustomField> {
  return optionsApi
    .post("v1/customFields", dto)
    .then((res) => res.data.data.customField);
}

export async function updateCustomField(
  id: string,
  dto: UpdateCustomFieldDto
): Promise<CustomField> {
  return optionsApi
    .put(`v1/customFields/${id}`, dto)
    .then((res) => res.data.data.customField);
}

export async function deactivateCustomField(id: string): Promise<void> {
  return optionsApi.patch(`v1/customFields/${id}/deactivate`);
}

export async function reorderCustomFields(
  entityType: UdfEntityType,
  orderedIds: string[]
): Promise<CustomField[]> {
  return optionsApi
    .post("v1/customFields/reorder", { entityType, orderedIds })
    .then((res) => res.data.data.customFields);
}
